import { Modal } from "@mantine/core";
import { useResponsiveBreakpoints } from "octalog-base";
import { useEffect } from "react";

import type { ContactResponseDto } from "../../../generated/client/octalog-service";
import { transformInitialData, useContactForm } from "../../../views/contacts/new/common/useContactForm";
import { ContactForm } from "../../../views/contacts/new/ContactForm";

interface EditContactModalProps {
  opened: boolean;
  onClose: () => void;
  contact: ContactResponseDto;
}

export function EditContactModal({ opened, onClose, contact }: EditContactModalProps) {
  const { form, handleSubmit } = useContactForm(contact);
  const { isMobile } = useResponsiveBreakpoints();

  const formSetValues = form.setValues;
  useEffect(() => {
    formSetValues(transformInitialData(contact));
  }, [contact, formSetValues]);

  return (
    <Modal fullScreen={isMobile} onClose={onClose} opened={opened} size="auto">
      <ContactForm form={form} onSubmit={handleSubmit} />
    </Modal>
  );
}
